import { createFileRoute, Link } from '@tanstack/react-router'
import { useState } from 'react'
import { authClient } from '@/lib/auth-client'
import { Button } from '@/components/ui/button'
import { ChonkyButton } from '@/components/shared/chonky-button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card, CardContent, CardDescription, CardHeader } from '@/components/ui/card'
import { RafobaseLogo } from '@/components/rafobase-logo'

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordPage,
})

function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setIsLoading(true)

    try {
      const { error: apiError } = await authClient.requestPasswordReset({
        email,
        redirectTo: `${window.location.origin}/reset-password`,
      })

      if (apiError) {
        console.error('Password reset request error:', apiError)
      }

      setIsSuccess(true)
    } catch (err) {
      console.error(err)
      // Standardize generic error view
      setIsSuccess(true)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1 text-center">
          <div className="flex justify-center mb-4">
            <RafobaseLogo className="h-12 w-auto text-foreground" />
          </div>
          <CardDescription>
            {isSuccess
              ? 'Verifique seu e-mail para redefinir a senha'
              : 'Insira seu e-mail para solicitar a redefinição de senha'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {isSuccess ? (
            <div className="space-y-4 text-center">
              <div className="p-3 text-sm text-green-800 bg-green-100 rounded-md">
                Se o e-mail existir em nossa base, um link de redefinição foi enviado.
              </div>
              <Button asChild variant="outline" className="w-full mt-4">
                <Link to="/login">Voltar para o login</Link>
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="p-3 text-sm text-destructive bg-destructive/10 rounded-md">
                  {error}
                </div>
              )}

              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={isLoading}
                />
              </div>

              <ChonkyButton
                type="submit"
                className="w-full"
                disabled={isLoading}
                loading={isLoading}
              >
                Enviar Link de Redefinição
              </ChonkyButton>
              <div className="text-center mt-4">
                <Link
                  to="/login"
                  className="text-sm font-medium text-muted-foreground hover:text-primary"
                >
                  Lembrou da senha? Volte para o login
                </Link>
              </div>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
